import { useEffect, useState } from 'react'
import { useTextEditor } from './TextEditorContext'

/** Активный редактор текста на холсте и есть ли в нём выделение — с подпиской на
 *  смену выделения (иначе панель о нём не узнала бы). */
export const useTextSelection = () => {
  const { activeEditor } = useTextEditor()
  const [, setTick] = useState(0)
  useEffect(() => {
    if (!activeEditor) return
    const rerender = () => setTick((t) => t + 1)
    activeEditor.on('selectionUpdate', rerender)
    activeEditor.on('transaction', rerender)
    return () => {
      activeEditor.off('selectionUpdate', rerender)
      activeEditor.off('transaction', rerender)
    }
  }, [activeEditor])
  return {
    editor: activeEditor,
    hasSelection: Boolean(activeEditor && !activeEditor.state.selection.empty),
  }
}
